import DataStreamScreen from './DataStreamScreen';

export default DataStreamScreen;
